import {RETURNS_ROUTES as returnsRoutes} from "@/api/routes";
import moment from "moment";

export const  state = () => ({
  returnedOrders: [],
  filter:{},
})

export const  getters = {
  returnedOrders: state => {
    let {filter} = state;
    return _.filter(state.returnedOrders, (obj) =>{
      return (!filter.nom || (filter.nom && obj.commande.compte.nom.toLowerCase().search(filter.nom.toLowerCase()) != -1)) &&
        (!filter.prenom || (filter.prenom && obj.commande.compte.prenom.toLowerCase().search(filter.prenom.toLowerCase()) != -1)) &&
        (!filter.productName || (filter.productName && obj.product.nom_affichage.toLowerCase().search(filter.productName.toLowerCase()) != -1)) &&
        (!filter.marque || (filter.marque && obj.marque.nom.toLowerCase().search(filter.marque.toLowerCase()) != -1)) &&
        (!filter.returnSubject || (filter.returnSubject && obj.motif.toLowerCase().search(filter.returnSubject.toLowerCase()) != -1)) &&
        (!filter.start_date || (filter.start_date && moment(obj.retourner_a).isSameOrAfter(filter.start_date))) &&
        (!filter.end_date || (filter.end_date && moment(obj.retourner_a).isSameOrBefore(filter.end_date )))
    });
  },
}
export  const mutations = {
  SET_ORDERS(state, orders)
  {
    state.returnedOrders = orders;
  },
  UPDATE_STATE(state, params)
  {
    state.returnedOrders = state.returnedOrders.map(order => {
      if (order.return_id === params.id)
        order.statut = params.data.statut;
      return order;
    });
  },
  SET_FILTER(state, params){
    state.filter = params;
  }
}
export  const actions = {
  async list({ commit }, params){
    return new Promise((resolve, reject) => {
      this.$api.request(returnsRoutes.list).then(res =>{
        commit('SET_ORDERS', res.payload);
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  async changeStatus({ commit }, params){
    return new Promise((resolve, reject) => {
      this.$api.request(returnsRoutes.status, {id: params.id}, params.data).then(res =>{
        commit('UPDATE_STATE', params)
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  setFilter({commit}, params){
    commit('SET_FILTER', params);
  }
}
